export default __webpack_public_path__ + "static/media/viewdetails.9c6ce9b2.svg";